import React from 'react';
import { Modal, Image } from 'antd';

const PrivateAuctionModal = ({ visible, onCancel }) => {
    return (
        <Modal
            title="Private Auction Instructions"
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={800}
        >
            <div style={{ textAlign: 'center' }}>
                <Image
                    src="/assets/images/inviteSteps.jpg"
                    alt="Invite Participants Steps"
                    style={{ maxWidth: '100%', borderRadius: 8 }}
                    preview={false}
                />
            </div>
        </Modal>
    );
};

export default PrivateAuctionModal; 